import { Navigate, useLocation } from 'react-router-dom';
import { hasValidSession, isPsychologist } from '../hooks/api';

interface ProtectedRouteProps {
  children: JSX.Element;
  requirePsychologist?: boolean;
}

export const ProtectedRoute = ({ 
  children, 
  requirePsychologist = true 
}: ProtectedRouteProps) => {
  const location = useLocation();
  const isAuthenticated = hasValidSession();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requirePsychologist && !isPsychologist()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export function checkAuth(): boolean {
  return hasValidSession();
}

export function checkPsychologistAuth(): boolean {
  return hasValidSession() && isPsychologist();
}

